import { useStore } from 'effector-react'
import { $budgetItem, sectionListForSelectMounted } from './model'
import { useLayoutEffect } from 'react'
import { $sectionList } from '../../sections/list/model'

export const useCreateBudgetItem = () => {
  const budgetItem = useStore($budgetItem)
  const section = useStore($sectionList)

  useLayoutEffect(() => {
    sectionListForSelectMounted()
  }, [])

  return { budgetItem, section }
}
